export const Abstract04Icon = () => {
  return (
    <svg
      width="125"
      height="125"
      viewBox="0 0 125 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.2806 55.8311C13.0011 55.8311 0.614746 43.4447 0.614746 28.1652V0.499744H28.2806C43.5601 0.499744 55.9465 12.8861 55.9465 28.1652C55.9465 43.4447 43.5601 55.8311 28.2806 55.8311Z"
        fill="url(#paint0_linear_1866_18431)"
      />
      <path
        d="M96.7274 55.8311C81.4479 55.8311 69.0615 43.4447 69.0615 28.1652C69.0615 12.8861 81.4479 0.499744 96.7274 0.499744H124.393V28.1652C124.393 43.4447 112.007 55.8311 96.7274 55.8311Z"
        fill="url(#paint1_linear_1866_18431)"
      />
      <path
        d="M28.5028 124.389H0.836914V96.7228C0.836914 81.4437 13.2233 69.0574 28.5028 69.0574C43.7823 69.0574 56.1687 81.4437 56.1687 96.7228C56.1687 112.002 43.7823 124.389 28.5028 124.389Z"
        fill="url(#paint2_linear_1866_18431)"
      />
      <path
        d="M124.615 124.389H96.9491C81.6701 124.389 69.2837 112.002 69.2837 96.7228C69.2837 81.4437 81.6701 69.0574 96.9491 69.0574C112.229 69.0574 124.615 81.4437 124.615 96.7228V124.389Z"
        fill="url(#paint3_linear_1866_18431)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_18431"
          x1="28.2806"
          y1="0.499744"
          x2="28.2806"
          y2="55.8311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1866_18431"
          x1="96.7274"
          y1="0.499744"
          x2="96.7274"
          y2="55.8311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1866_18431"
          x1="28.5028"
          y1="69.0574"
          x2="28.5028"
          y2="124.389"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1866_18431"
          x1="96.9493"
          y1="69.0574"
          x2="96.9493"
          y2="124.389"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
};
